import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PropertyCharacteristicsDto, PropertyEquipment } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../../pipes/etxe-enum-display.pipe';
import { getPropertyEquipmentInfo } from '../../equipments-list/property-equipment.constants';

@Component({
  selector: 'etxe-property-characteristics-display',
  standalone: true,
  imports: [CommonModule, MatIconModule, EtxeEnumDisplayPipe],
  templateUrl: './characteristics-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyCharacteristicsDisplayComponent {
  characteristics = input.required<PropertyCharacteristicsDto>();

  totalInteriorSurface = computed(() => {
    const interior = this.characteristics()?.interior;
    if (!interior) return 0;
    let total = 0;
    interior.rooms?.forEach((r) => (total += r.surface || 0));
    interior.bedroom?.forEach((b) => (total += b.surface || 0));
    interior.bathroom?.forEach((b) => (total += b.surface || 0));
    interior.showerRoom?.forEach((s) => (total += s.surface || 0));
    return total;
  });

  totalExteriorSurface = computed(() => {
    const exterior = this.characteristics()?.exterior;
    if (!exterior) return 0;
    let total = 0;
    exterior.garden?.forEach((g) => (total += g.surface || 0));
    exterior.terrace?.forEach((t) => (total += t.surface || 0));
    exterior.balcony?.forEach((b) => (total += b.surface || 0));
    exterior.loggia?.forEach((l) => (total += l.surface || 0));
    exterior.swimmingPool?.forEach((p) => (total += p.surface || 0));
    exterior.cellar?.forEach((c) => (total += c.surface || 0));
    return total;
  });

  hasExterior = computed(() => {
    const exterior = this.characteristics()?.exterior;
    if (!exterior) return false;
    return (
      (exterior.garden?.length ?? 0) > 0 ||
      (exterior.terrace?.length ?? 0) > 0 ||
      (exterior.balcony?.length ?? 0) > 0 ||
      (exterior.loggia?.length ?? 0) > 0 ||
      (exterior.swimmingPool?.length ?? 0) > 0 ||
      (exterior.cellar?.length ?? 0) > 0
    );
  });

  totalParkingSurface = computed(() => {
    return (this.characteristics()?.parkings || []).reduce((acc, p) => acc + (p.totalSurface || 0), 0);
  });

  totalCommonAreasSurface = computed(() => {
    return (this.characteristics()?.commonAreas || []).reduce((acc, a) => acc + (a.surface || 0), 0);
  });

  getEquipmentInfo(type: PropertyEquipment): { icon: string; label: string } {
    return getPropertyEquipmentInfo(type);
  }
}
